<script>
    import Fa from 'svelte-fa';
    import { faShare } from '@fortawesome/pro-regular-svg-icons';

    import { browser } from '$app/environment';
    import WebAppPrompt from '$lib/components/WebAppPrompt.svelte';

    export let content = [];
    export let modulePosition;
    export let sectionPosition;

    const action = content?.action;

    const isShareAvailable = browser && navigator && 'share' in navigator ? true : false;
</script>

<div data-moduleposition={modulePosition}>
    {#if action === 'PWA Prompt'}
        <WebAppPrompt />
    {/if}
    {#if action === 'Share Button' && isShareAvailable}
        <button
            class="flex w-full items-center justify-center rounded-full bg-primary px-6 py-3 font-semibold text-white shadow-md lg:w-auto"
            on:click={() => {
                navigator
                    .share({
                        title: content?.share?.title,
                        text: '',
                        url: content?.share?.URL
                    })
                    .catch((error) => {
                        if (error.name === 'AbortError') {
                            return void 0;
                        }
                    });
            }}
            aria-label="Share button"
        >
            <Fa icon={faShare} size="1x" class="mr-2 inline-block" /> <span>{content?.share?.title || 'Share'}</span>
        </button>
    {/if}
</div>
